import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/root/workspace/__flow_work/__flow_builds/3ed4544c-3c2a-4c7a-9f23-032dcb22c824/workspace/streffy-middle-office_rVCL/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var basePre = 'report-center';
var meta = {
  auth: true,
  closable: true
};
export default [{
  path: "/".concat(basePre),
  title: '报表中心',
  name: "".concat(basePre),
  header: "".concat(basePre),
  icon: 'md-stats',
  redirect: {
    name: 'sales-analysis'
  },
  meta: meta,
  component: 'layouts/basic-layout',
  children: [{
    path: 'sales-analysis',
    title: '报表首页',
    name: 'sales-analysis',
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '报表首页'
    }),
    component: "pages/".concat(basePre, "/sales-analysis/index")
  },
  // 临时注释业务统计，因为页面文件不存在
  // {
  //     path: 'business-statistics',
  //     title: '业务统计',
  //     name: 'business-statistics',
  //     meta: {
  //         ...meta,
  //         title: '业务统计'
  //     },
  //     component: `pages/${basePre}/business-statistics/index`
  // },
  {
    path: 'data-dashboard',
    title: '数据看板',
    name: 'data-dashboard',
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '数据看板'
    }),
    component: "pages/".concat(basePre, "/data-dashboard/index")
  }, {
    path: 'order-detail',
    title: '订单明细表',
    name: 'report-order-detail',
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '订单明细表'
    }),
    component: "pages/".concat(basePre, "/order-detail/index")
  }, {
    path: 'product-analysis',
    title: '商品分析',
    name: 'report-product-analysis',
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '商品分析'
    }),
    component: "pages/".concat(basePre, "/product-analysis/index")
  }, {
    path: 'sales-order',
    title: '销售订单报表',
    name: 'report-sales-order',
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '销售订单报表'
    }),
    component: "pages/".concat(basePre, "/sales-order/index")
  }, {
    path: 'sales-order-summary',
    title: '销售订单汇总报表',
    name: 'report-sales-order-summary',
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '销售订单汇总报表'
    }),
    component: "pages/".concat(basePre, "/sales-order-summary/index")
  }, {
    path: 'customer-analysis',
    title: '客单分析',
    name: 'report-customer-analysis',
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '客单分析'
    }),
    component: "pages/".concat(basePre, "/customer-analysis/index")
  }, {
    path: 'test',
    title: '测试页面',
    name: 'report-test',
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '测试页面'
    }),
    component: "pages/".concat(basePre, "/test")
  }]
}];